import { PrimaryButton } from "@fluentui/react/lib/Button";
import React from "react";
import { Icon } from "@fluentui/react/lib/Icon";

interface Props {
  text: string;
  onClick?: () => any;
  baseTypeProps?: any;
}

const SaveButton = (props: Props) => {
  return (
    <>
      <PrimaryButton
        text={props.text}
        onClick={props.onClick}
        {...props.baseTypeProps}
      >
        <Icon iconName="Save" />
      </PrimaryButton>
    </>
  );
};

export default SaveButton;
